// extracted by mini-css-extract-plugin
export default {"configName":"EditableNameInput_configName__q0PIj"};